module.exports = __webpack_public_path__ + "static/media/loginbg.84d2f9cb.jpg";